(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["promo-bar"]) return;
  try {
    
$( document ).ready(function() {
    var swiper = new Swiper("#promotion-bar", {
      spaceBetween: 0,
      slidesPerView: 1,
      freeMode: false,
      loop:true,
      autoplay: {
        delay: 5000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
});



  } catch(e) { console.error(e); }
})();
      })();
